import React from 'react'
import { AppRouter } from '~/src/app/AppRouter'
import { useShopBootstrap } from '~/src/app/hooks/useShopBootstrap'
import { ShopShell } from '~/src/shared/ui/ShopShell'

export default function ShopApp() {
  const { loading } = useShopBootstrap()

  if (loading) {
    return (
      <ShopShell>
        <div className="shop-section narrow">
          <p>Cargando tienda...</p>
        </div>
      </ShopShell>
    )
  }

  return (
    <ShopShell>
      <AppRouter />
    </ShopShell>
  )
}
